
import React, { Component } from 'react';
import { Icon, Row, Col, Input, Divider, Select, DatePicker, Button, message, Tabs, Table, Modal } from 'antd';
import moment from 'moment';
import country from './../../../countries';
import $ from 'jquery';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import NewAssets from './childs/asset';

// Actions
import { 
    delete_asset_log, 
    set_date_return_asset_log, 
    set_date_given_asset_log, 
    set_log_notes } from './../actions/employee.edit.action'

const Option = Select.Option;
const { MonthPicker, RangePicker, WeekPicker } = DatePicker;
const { TextArea } = Input;
const dateFormat = 'YYYY-MM-DD';
const todayDate = moment().format('YYYY-MM-DD');
const { TabPane } = Tabs;
const { confirm } = Modal;
let timer,x;

class About extends Component {

    constructor( props ){
        super( props );

        this.state = {
            full_name: '',
            nick_name: '',
            passport_number: '',
            passport_place_issue: '',
            passport_issue: '',
            passport_expiry: '',
            religion: '',
            email_id: '',
            department_id: '',
            reporting_to: '',
            designation_id: '',
            date_of_joining: '',
            employee_status: '',
            employee_type: '',
            work_phone: '',
            extension: '',
            role: '',
            company_id: '',
            mobile_phone: '',
            other_email: '',
            country: '',
            states: '',
            birth_date: '',
            gender: '',
            marital_status: '',
            address: '',
            homeaddress: '',
            emergency_contact_1: '',
            emergency_contact_2: '',
            emergency_contact_name_1: '',
            emergency_contact_name_2: '',
            emergency_contact_relation_1: '',
            emergency_contact_relation_2: '',
            job_description: '',
            about_me: '',
            expertise_description: '',
            visa_uid: '',
            visa_issue_date: '',
            visa_expiry_date: '',
            emirates_id: '',
            emirates_expiry: '',
            tecom_id: '',
            tecom_expiry: '',
            bank_name: '',
            bank_iban: '',
            bank_acc_number: '',
            bank_acc_name: '',
            bank_swift: '',
            bank_address: '',
            visa_sponsor: '',
            date_of_exit: '',
            insurance_id: '',
            insurance_name: '',
            insurance_expiry: '',
            documents: [],
            assets: [],
            assets_option: [],
            mother: '',
            father: '',
            relate_department: []
        }

        this.handleBack = this.handleBack.bind( this );
        this.handleUpdate = this.handleUpdate.bind( this );
        this.handleDocuments = this.handleDocuments.bind( this );
        this.handleDeleteAsset = this.handleDeleteAsset.bind( this );

        this.handlesetDateReturn = this.handlesetDateReturn.bind( this );
        this.handlesetDateGiven = this.handlesetDateGiven.bind( this );
        this.handleRelatedDepartment = this.handleRelatedDepartment.bind( this );

    }

    handleRelatedDepartment( value ){
        this.setState({ relate_department: value });
    }

    handlesetDateGiven( id, date ){
        this.props.set_date_given_asset_log( id, date );
    }

    handlesetDateReturn( id, date ){
        this.props.set_date_return_asset_log( id, date );
    }

    handleNotes( id, value ){
        
        let self = this;
        clearTimeout(timer);
        timer = setTimeout(() => {
            self.props.set_log_notes( id, value );
        }, 800);

    }

    handleDeleteAsset( log_id ){
        
        let self = this;

        confirm({
            title: 'Do you Want to delete these items?',
            onOk() {
                self.props.delete_asset_log( log_id );
            },
            onCancel() {
                // Nothing ...
            }
        });

    }

    handleDocuments( e ){

        var fdata = new FormData();
        var user_id =  this.props.match.params.id;
        
        if( e.target.files.length>0 ){

            $.each( e.target.files, function( i, file ){
                
                if( file.size >= 524288000 ){
                    message.error( "File Size too Big", "error" );
                    return false;
                }
                
                fdata.append( "file"+[i], file );
                fdata.append( "user_id", user_id );
                
            });
        }

        this.props.onDocument( fdata );

        e.target.value = '';

    }

    handleUpdate(){
        this.props.onSubmit( this.state );
    }

    handleBack(){
        this.props.onBack();
    }

    componentWillReceiveProps( nextProps ){
        

        if( nextProps.onAssets.length != 0 ){
            this.setState({ assets_option: nextProps.onAssets });
        }
        
        if( nextProps.data ){

            this.setState({
                full_name: nextProps.data.full_name,
                nick_name: nextProps.data.nick_name,
                email_id: nextProps.data.user_email,
                department_id: nextProps.data.department_id,
                reporting_to: nextProps.data.reporting_to,
                designation_id: nextProps.data.designation_id,
                date_of_joining: nextProps.data.date_of_joining,
                date_of_exit: nextProps.data.date_of_exit,
                employee_status: nextProps.data.employee_status,
                employee_type: nextProps.data.employee_type,
                visa_sponsor: nextProps.data.visa_sponsor,
                work_phone: nextProps.data.work_phone,
                extension: nextProps.data.extension,
                role: nextProps.data.role,
                company_id: nextProps.data.company_id,
                mobile_phone: nextProps.data.mobile_phone,
                other_email: nextProps.data.other_email,
                country: nextProps.data.country,
                states: nextProps.data.states,
                birth_date: nextProps.data.birth_date,
                gender: nextProps.data.gender,
                marital_status: nextProps.data.marital_status,
                religion: nextProps.data.religion,
                address: nextProps.data.address,
                emergency_contact_1: nextProps.data.emergency_contact_1,
                emergency_contact_name_1: nextProps.data.emergency_contact_name_1,
                emergency_contact_relation_1: nextProps.data.emergency_contact_relation_1,
                homeaddress: nextProps.data.homeaddress,
                emergency_contact_2: nextProps.data.emergency_contact_2,
                emergency_contact_name_2: nextProps.data.emergency_contact_name_2,
                emergency_contact_relation_2: nextProps.data.emergency_contact_relation_2,
                job_description: nextProps.data.job_description,
                about_me: nextProps.data.about_me,
                expertise_description: nextProps.data.expertise_description,
                bank_name: nextProps.data.bank_name,
                bank_iban: nextProps.data.bank_iban,
                bank_acc_number: nextProps.data.bank_acc_number,
                bank_acc_name: nextProps.data.bank_acc_name,
                bank_swift: nextProps.data.bank_swift,
                bank_address: nextProps.data.bank_address,
                passport_number: nextProps.data.passport_number,
                passport_place_issue: nextProps.data.passport_place_issue,
                passport_issue: nextProps.data.passport_issue,
                passport_expiry: nextProps.data.passport_expiry,
                visa_uid: nextProps.data.visa_uid,
                visa_issue_date: nextProps.data.visa_issue_date,
                visa_expiry_date: nextProps.data.visa_expiry_date,
                emirates_id: nextProps.data.emirates_id,
                emirates_expiry: nextProps.data.emirates_expiry,
                tecom_id: nextProps.data.tecom_id,
                tecom_expiry: nextProps.data.tecom_expiry,
                insurance_id: nextProps.data.insurance_id,
                insurance_name: nextProps.data.insurance_name,
                insurance_expiry: nextProps.data.insurance_expiry,
                documents: nextProps.data.documents,
                assets: nextProps.data.assets,
                mother: nextProps.data.mother,
                father: nextProps.data.father,
                relate_department: ( nextProps.data.relate_department ) ? JSON.parse( nextProps.data.relate_department ) : []
            });

        
        }

    }


    render() {

        const department_list = this.props.department_data.map( ( item, i ) => 
            <Option key={ item.department_id }>{ item.department_name }</Option> );

        const employee_list = this.props.employee_data.map( ( item, i ) => 
            <Option key={ item.user_id }>{ item.full_name }</Option> );

        const designation_list = this.props.designation_data.map( ( item, i ) => 
            <Option key={ item.designation_id }>{ item.designation_name }</Option> );

        const company_list = this.props.company_data.map( ( item, i ) => 
            <Option key={ item.company_id }>{ item.company_name }</Option> );

        const country_list = country.countries.map( ( item, i ) => 
            <Option key={ item.country }>{ item.country }</Option> )

        const state_list = country.countries.map( ( item, i ) => {
            if( item.country === this.state.country ){

                return item.states.map( ( value, k ) => <Option key={ value }>{ value }</Option> )

            }
        });

        let documents_list
        if( this.state.documents ){
            documents_list = this.state.documents.map( (item, i) => <li key={i}>
                <span>{  item.document_name }</span>
                <Button size="small" icon="delete" className="fl_right mrg_t_10 mrg_r_10" onClick={ ()=> this.props.onDocDelete( item.document_id )} type="danger"></Button>
                <a href={ item.document_path } target="_blank">
                    <Button size="small" icon="cloud-download" className="fl_right mrg_t_10 mrg_r_10"></Button>
                </a>
            </li> );
        }

        const asset_columns = [
            {
                title: 'Device Type',
                dataIndex: 'device_type',
                key: 'device_type',
                width: '15%'
            },{
                title: 'Device Model',
                dataIndex: 'device_modal',
                key: 'device_modal',
            },{
                title: 'Notes',
                key: 'notes',
                render: ( data ) => <Input defaultValue={ data.notes } onChange={ (e) => this.handleNotes( data.log_id, e.target.value ) } />
            },{
                title: 'Date Given',
                key: '',
                render: ( data ) => <span>
                    <DatePicker 
                        style={{ width: '100%' }}
                        onChange={ (date, dateString ) => this.handlesetDateGiven( data.log_id, dateString  ) }
                        defaultValue={ moment( data.date_given, dateFormat ) } />
                </span>,
                width: '20%'
            },{
                title: 'Date Return',
                render: ( data ) => <span>
                    <DatePicker
                        style={{ width: '100%' }}
                        onChange={ (date, dateString ) => this.handlesetDateReturn( data.log_id, dateString  ) }
                        defaultValue={ moment( data.date_return, dateFormat ) } />
                </span>,
                width: '20%'
            },{
                title: 'Actions',
                render: (data) => <span>
                    <Link to={"/prints/asset/"+ data.log_id }><Button size={ "small" } type="primary" icon="printer" /></Link>
                    &nbsp;
                    <Button 
                        onClick={ ()=> this.handleDeleteAsset( data.log_id ) }
                        size={ "small" } type="danger" icon="delete" />
                </span>,
                width: '10%'
            }
        ]

        return (
            <div className="employee_edit">

                <h2>
                    <Icon type="user" />
                    &nbsp; Update Employee Details
                </h2>

                <Divider />

                <Tabs defaultActiveKey="1" >
                    <TabPane tab="Basic Informations" key="1">
                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Employee Full Name</label>
                                <Input 
                                    onChange={ (e) => this.setState({ full_name: e.target.value }) }
                                    value={ this.state.full_name } size="default" />
                            </Col>
                            <Col span={12}>
                                <label>Employee Nick Name</label>
                                <Input
                                    onChange={ (e) => this.setState({ nick_name: e.target.value }) } 
                                    value={ this.state.nick_name } size="default" />
                            </Col>
                        </Row>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Email ID ( Digital Venture ) </label>
                                <Input
                                    onChange={ (e) => this.setState({ email_id: e.target.value }) } 
                                    value={ this.state.email_id } size="default" />
                            </Col>
                        </Row>

                        <Divider style={{fontSize: 12, color: '#999'}}>Work Details</ Divider>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Department</label>
                                <Select 
                                    onChange={ (value) => this.setState({ department_id: value }) }
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    showSearch value={ this.state.department_id } style={{ width: '100%' }}>
                                    { department_list }
                                </Select>
                            </Col>
                            <Col span={12}>
                                <label>Reporting To</label>
                                <Select 
                                    onChange={ (value) => this.setState({ reporting_to: value }) }
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    showSearch value={ this.state.reporting_to } style={{ width: '100%' }}>
                                    { employee_list }
                                </Select>
                            </Col>
                        </Row>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Related Department</label>
                                <Select 
                                    mode="multiple"
                                    onChange={ this.handleRelatedDepartment }
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    showSearch 
                                    style={{ width: '100%' }}
                                    value={ this.state.relate_department }>
                                    { department_list }
                                </Select>
                            </Col>
                            <Col span={12}>

                            </Col>
                        </Row>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Designation</label>
                                <Select 
                                    onChange={ (value) => this.setState({ designation_id: value }) }
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    showSearch value={ this.state.designation_id } style={{ width: '100%' }}>
                                    { designation_list }
                                </Select>
                                
                            </Col>
                            <Col span={12}>
                                <label>Date of Joining</label>
                                <DatePicker 
                                    onChange={ ( date, date_string ) => this.setState({ date_of_joining: date_string }) }
                                    value={moment( this.state.date_of_joining, dateFormat)} style={{ width: '100%' }} />
                            </Col>
                        </Row>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Visa sponsorship</label>
                                <Select 
                                    onChange={ (value) => this.setState({ visa_sponsor: value }) }
                                    value={ this.state.visa_sponsor } style={{ width: '100%' }}>
                                    <Option value="N/A">N/A</Option>
                                    <Option value="company">Company</Option>
                                    <Option value="family">Family</Option>
                                    <Option value="student">Student</Option>
                                </Select>
                            </Col>
                            <Col span={12}>
                                <label>Date of Exit</label>
                                <DatePicker 
                                    onChange={ ( date, date_string ) => this.setState({ date_of_exit: date_string }) }
                                    value={moment( this.state.date_of_exit, dateFormat)} style={{ width: '100%' }} />
                            </Col>
                        </Row>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Employee status</label>
                                <Select 
                                    onChange={ (value) => this.setState({ employee_status: value }) }
                                    value={ this.state.employee_status } style={{ width: '100%' }}>
                                    <Option value="active">Active</Option>
                                    <Option value="terminated">Terminated</Option>
                                    <Option value="deceased">Deceased</Option>
                                    <Option value="resigned">Resigned</Option>
                                </Select>
                            </Col>
                            <Col span={12}>
                                <label>Employee Type</label>
                                <Select 
                                    onChange={ (value) => this.setState({ employee_type: value }) }
                                    value={ this.state.employee_type } style={{ width: '100%' }}>
                                    <Option value="permanent">Permanent</Option>
                                    <Option value="oncontract">On Contract</Option>
                                    <Option value="temporary">Temporary</Option>
                                    <Option value="trainee">Trainee</Option>
                                    <Option value="probation">Probation</Option>
                                </Select>
                            </Col>
                        </Row>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Work Phone</label>
                                <Input
                                    onChange={ (e) => this.setState({ work_phone: e.target.value }) }
                                    value={ this.state.work_phone } size="default" />
                            </Col>
                            <Col span={12}>
                                <label>Extension Number</label>
                                <Input 
                                    onChange={ (e) => this.setState({ extension: e.target.value }) }
                                    value={ this.state.extension } size="default" />
                            </Col>
                        </Row>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Role</label>
                                <Select 
                                    onChange={ ( value ) => this.setState({ role: value }) }
                                    value={ this.state.role } style={{ width: '100%' }}>
                                    <Option value="admin">Admin</Option>
                                    <Option value="teammember">Team Member</Option>
                                    <Option value="manager">Manager</Option>
                                    <Option value="director">Director</Option>
                                    <Option value="teamincharge">Team Incharge</Option>
                                </Select>
                            </Col>

                            <Col span={12}>
                                <label>Company</label>
                                <Select
                                    onChange={ (value) => this.setState({ company_id: value }) }
                                    value={ this.state.company_id } style={{ width: '100%' }}>
                                    { company_list }
                                </Select>
                            </Col>
                        </Row>

                    </TabPane>
                    <TabPane tab="Work Related" key="2">
                        

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Bank Name</label>
                                <Input
                                    onChange={ (e) => this.setState({ bank_name: e.target.value }) } 
                                    value={ this.state.bank_name } size="default" />
                            </Col>
                            <Col span={12}>
                                <label>Account Name</label>
                                <Input
                                    onChange={ (e) => this.setState({ bank_acc_name: e.target.value }) } 
                                    value={ this.state.bank_acc_name } size="default" />
                            </Col>
                        </Row>
                        
                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>IBAN Number</label>
                                <Input
                                    onChange={ (e) => this.setState({ bank_iban: e.target.value }) } 
                                    value={ this.state.bank_iban } size="default" />
                            </Col>
                            <Col span={12}>
                                <label>Account Number</label>
                                <Input
                                    onChange={ (e) => this.setState({ bank_acc_number: e.target.value }) } 
                                    value={ this.state.bank_acc_number } size="default" />
                            </Col>
                        </Row>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Swift Code</label>
                                <Input
                                    onChange={ (e) => this.setState({ bank_swift: e.target.value }) } 
                                    value={ this.state.bank_swift } size="default" />
                            </Col>
                            <Col span={12}>
                                <label>Bank Address</label>
                                <Input
                                    onChange={ (e) => this.setState({ bank_address: e.target.value }) } 
                                    value={ this.state.bank_address } size="default" />
                            </Col>
                        </Row>

                        <Divider style={{fontSize: 12, color: '#999'}}>Passport Details</ Divider>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Passport Number</label>
                                <Input
                                    onChange={ (e) => this.setState({ passport_number: e.target.value }) } 
                                    value={ this.state.passport_number } size="default" />
                            </Col>
                            <Col span={12}>
                                <label>Place of Issue</label>
                                <Input
                                    onChange={ (e) => this.setState({ passport_place_issue: e.target.value }) } 
                                    value={ this.state.passport_place_issue } size="default" />
                            </Col>
                        </Row>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Date of Issue</label>
                                <DatePicker 
                                    onChange={ ( date, date_string ) => this.setState({ passport_issue: date_string }) }
                                    value={moment( this.state.passport_issue, dateFormat)} style={{ width: '100%' }} />
                            </Col>
                            <Col span={12}>
                                <label>Date of Expiry</label>
                                <DatePicker 
                                    onChange={ ( date, date_string ) => this.setState({ passport_expiry: date_string }) }
                                    value={moment( this.state.passport_expiry, dateFormat)} style={{ width: '100%' }} />
                            </Col>
                        </Row>

                        <Divider style={{fontSize: 12, color: '#999'}}>Residency Visa Details</ Divider>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>UID#</label>
                                <Input
                                    onChange={ (e) => this.setState({ visa_uid: e.target.value }) } 
                                    value={ this.state.visa_uid } size="default" />
                            </Col>
                            <Col span={12}>
                                <label>Issue Date</label>
                                <DatePicker 
                                    onChange={ ( date, date_string ) => this.setState({ visa_issue_date: date_string }) }
                                    value={moment( this.state.visa_issue_date, dateFormat)} style={{ width: '100%' }} />
                            </Col>
                        </Row>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Date of Expiry</label>
                                <DatePicker 
                                    onChange={ ( date, date_string ) => this.setState({ visa_expiry_date: date_string }) }
                                    value={moment( this.state.visa_expiry_date, dateFormat)} style={{ width: '100%' }} />
                            </Col>
                        </Row>

                        <Divider style={{fontSize: 12, color: '#999'}}>Emirates ID Details</ Divider>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>ID#</label>
                                <Input
                                    onChange={ (e) => this.setState({ emirates_id: e.target.value }) } 
                                    value={ this.state.emirates_id } size="default" />
                            </Col>
                            <Col span={12}>
                                <label>Date of Expiry</label>
                                <DatePicker 
                                    onChange={ ( date, date_string ) => this.setState({ emirates_expiry: date_string }) }
                                    value={moment( this.state.emirates_expiry, dateFormat)} style={{ width: '100%' }} />
                            </Col>
                        </Row>

                        <Divider style={{fontSize: 12, color: '#999'}}>Tecom ID Details</ Divider>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>ID#</label>
                                <Input
                                    onChange={ (e) => this.setState({ tecom_id: e.target.value }) } 
                                    value={ this.state.tecom_id } size="default" />
                            </Col>
                            <Col span={12}>
                                <label>Date of Expiry</label>
                                <DatePicker 
                                    onChange={ ( date, date_string ) => this.setState({ tecom_expiry: date_string }) }
                                    value={moment( this.state.tecom_expiry, dateFormat)} style={{ width: '100%' }} />
                            </Col>
                        </Row>

                        <Divider style={{fontSize: 12, color: '#999'}}>Insurance Details</ Divider>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>ID#</label>
                                <Input
                                    onChange={ (e) => this.setState({ insurance_id: e.target.value }) } 
                                    value={ this.state.insurance_id } size="default" />
                            </Col>
                            <Col span={12}>
                                <label>Insurance Company Name</label>
                                <Input
                                    onChange={ (e) => this.setState({ insurance_name: e.target.value }) } 
                                    value={ this.state.insurance_name } size="default" />
                            </Col>
                        </Row>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Expiry Date</label>
                                <DatePicker 
                                    onChange={ ( date, date_string ) => this.setState({ insurance_expiry: date_string }) }
                                    value={moment( this.state.insurance_expiry, dateFormat)} style={{ width: '100%' }} />
                            </Col>
                        </Row>

                    </TabPane>                    
                    <TabPane tab="Personal" key="3">
                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Mobile Number</label>
                                <Input 
                                    onChange={ (e) => this.setState({ mobile_phone: e.target.value }) }
                                    value={ this.state.mobile_phone } size="default" />
                            </Col>
                            <Col span={12}>
                                <label>Other Email</label>
                                <Input 
                                    onChange={ (e) => this.setState({ other_email: e.target.value }) }
                                    value={ this.state.other_email } size="default" />
                            </Col>
                        </Row>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Country</label>
                                <Select
                                    onChange={ (value) => this.setState({ country: value }) }
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    showSearch value={ this.state.country } style={{ width: '100%' }}>
                                    { country_list }
                                </Select>
                            </Col>
                            <Col span={12}>
                                <label>State</label> 
                                <Select
                                    onChange={ (value) => this.setState({ states: value }) }
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    showSearch value={ this.state.states } style={{ width: '100%' }}>
                                    { state_list }
                                </Select>
                            </Col>
                        </Row>


                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Date of Birth</label>
                                <DatePicker
                                    onChange={ ( date, date_string ) => this.setState({ birth_date: date_string }) }
                                    value={moment( this.state.birth_date, dateFormat)} style={{ width: '100%' }} />
                            </Col>
                            <Col span={12}>
                                <label>Gender</label> 
                                <Select 
                                    onChange={ ( value ) => this.setState({ gender: value }) }
                                    value={ this.state.gender } style={{ width: '100%' }}>
                                    <Option value="male">Male</Option>
                                    <Option value="female">Female</Option>
                                    <Option value="other">Other</Option>
                                </Select>
                            </Col>
                        </Row>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Marital Status</label> 
                                <Select 
                                    onChange={ ( value ) => this.setState({ marital_status: value }) }
                                    value={ this.state.marital_status } style={{ width: '100%' }}>
                                    <Option value="single">Single</Option>
                                    <Option value="married">Married</Option>
                                </Select>
                            </Col>
                            <Col span={12}>
                                <label>Religion</label>
                                <Select 
                                    onChange={ (value) => this.setState({ religion: value }) }
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    showSearch value={ this.state.religion } style={{ width: '100%' }}>
                                        <Option value="christianity">Christianity</Option>
                                        <Option value="islam">Islam</Option>
                                        <Option value="hinduism">Hinduism</Option>
                                        <Option value="buddhism">Buddhism</Option>
                                        <Option value="sikhism">Sikhism</Option>
                                        <Option value="judaism">Judaism</Option>
                                        <Option value="spiritism">Spiritism</Option>
                                        <Option value="bahai">Bahai</Option>
                                        <Option value="jainism">Jainism</Option>
                                        <Option value="shinto">Shinto</Option>
                                        <Option value="zoroastrianism">Zoroastrianism</Option>
                                        <Option value="tenrikyo">Tenrikyo</Option>
                                        <Option value="neo-paganism">Neo-Paganism</Option>
                                        <Option value="unitarian-universalism">Unitarian-Universalism</Option>
                                        <Option value="nonreligious">Nonreligious (Secular/Agnostic/Atheist)</Option>
                                </Select>
                            </Col>
                        </Row>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Current Address</label>
                                <TextArea 
                                    onChange={ (e) => this.setState({ address: e.target.value }) }
                                    value={ this.state.address } rows={4} />
                            </Col>
                            <Col span={12}>
                                <label>Home Country Address</label>
                                <TextArea 
                                    onChange={ (e) => this.setState({ homeaddress: e.target.value }) }
                                    value={ this.state.homeaddress } rows={4} />
                            </Col>
                        </Row>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Mother Name</label>
                                <Input 
                                    onChange={ (e) => this.setState({ mother: e.target.value }) }
                                    value={ this.state.mother } />
                            </Col>
                            <Col span={12}>
                                <label>Father Name</label>
                                <Input 
                                    onChange={ (e) => this.setState({ father: e.target.value }) }
                                    value={ this.state.father } />
                            </Col>
                        </Row>


                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Emergency Contact Person Name #1</label>
                                <Input 
                                    onChange={ (e) => this.setState({ emergency_contact_name_1: e.target.value }) }
                                    value={ this.state.emergency_contact_name_1 } size="default" />
                            </Col>
                            <Col span={12}>
                                <label>Emergency Contact Person Name #2</label>
                                <Input 
                                    onChange={ (e) => this.setState({ emergency_contact_name_2: e.target.value }) }
                                    value={ this.state.emergency_contact_name_2 } size="default" />
                            </Col>
                        </Row>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Relationship #1</label>
                                <Input 
                                    onChange={ (e) => this.setState({ emergency_contact_relation_1: e.target.value }) }
                                    value={ this.state.emergency_contact_relation_1 } size="default" />
                            </Col>
                            <Col span={12}>
                                <label>Relationship #2</label>
                                <Input 
                                    onChange={ (e) => this.setState({ emergency_contact_relation_2: e.target.value }) }
                                    value={ this.state.emergency_contact_relation_2 } size="default" />
                            </Col>
                        </Row>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Contact Number #1</label>
                                <Input 
                                    onChange={ (e) => this.setState({ emergency_contact_1: e.target.value }) }
                                    value={ this.state.emergency_contact_1 } size="default" />
                            </Col>
                            <Col span={12}>
                                <label>Contact Number #2</label>
                                <Input 
                                    onChange={ (e) => this.setState({ emergency_contact_2: e.target.value }) }
                                    value={ this.state.emergency_contact_2 } size="default" />
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tab="Documents" key="4">
                        <Row gutter={16} className="mrg_b_10">
                            <Col span={24}>
                                <input onChange={ this.handleDocuments } style={{ width: '100%', marginBottom: 10 }} type="file" multiple />
                                <div className="documents_wrapper">
                                    <ul className="file_list">
                                        { documents_list }
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tab="Assets" key="5">
                        
                        <NewAssets employee_id={ this.props.employee_id } onData={ this.state.assets_option } />

                        <br />

                        <Table 
                            size={'small'}
                            columns={ asset_columns } dataSource={ this.state.assets } />


                    </TabPane>
                    <TabPane tab="Summary" key="6">
                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Job Description</label> 
                                <TextArea 
                                    onChange={ (e) => this.setState({ job_description: e.target.value }) }
                                    value={ this.state.job_description } rows={4} />
                            </Col>
                            <Col span={12}>
                                <label>About Me</label>
                                <TextArea 
                                    onChange={ (e) => this.setState({ about_me: e.target.value }) }
                                    value={ this.state.about_me } rows={4} />
                            </Col>
                        </Row>

                        <Row gutter={16} className="mrg_b_10">
                            <Col span={12}>
                                <label>Ask me about/Expertise</label>
                                <TextArea 
                                    onChange={ (e) => this.setState({ expertise_description: e.target.value }) }
                                    value={ this.state.expertise_description } rows={4} />
                            </Col>
                        </Row>
                    </TabPane>
                </Tabs>

                <Divider />

                <Row gutter={16} className="mrg_t_30">
                    <Col span={12}>
                        <Button type="primary" onClick={ this.handleUpdate } >Update Info</Button>
                        <Button className="mrg_l_10" onClick={ this.handleBack }>Back</Button>
                    </Col>
                </Row>

            </div>
        )
    }
}


function mapStatetoProps( state ){
    return {
        employeeedit: state.employeeedit
    }
}

export default connect( mapStatetoProps, { 
    delete_asset_log, 
    set_date_return_asset_log, 
    set_date_given_asset_log, 
    set_log_notes } )( About );


// WEBPACK FOOTER //
// ./src/pages/employee.edit/childs/about.js